import { InformativeStatus } from '@/components/shared/informative-status/informative-status.types';
import { TranslateService } from '@ngx-translate/core';

interface getPpmNoContractingAuthorityInformativeStatusProps {
  subtitle: string;
  goToPpmCurrentPlans: () => void;
  translate: TranslateService;
}

export const getPpmNoContractingAuthorityInformativeStatus = ({
  goToPpmCurrentPlans,
  translate,
}: getPpmNoContractingAuthorityInformativeStatusProps): InformativeStatus => {
  return {
    title: 'ppm.informative.noAc.title',
    subtitle: translate.instant('ppm.informative.noAc.subtitle', { year: new Date().getFullYear() }),
    iconProps: { icon: 'pi pi-info-circle', class: 'text-primary text-[10rem]' },
    actionButton: {
      label: 'ppm.informative.noAc.button',
      onClick: goToPpmCurrentPlans,
    },
  };
};
